import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c4dbcdea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "team-base" }
const _hoisted_2 = { class: "team-group-tooltip" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "查看全部空间", -1))
const _hoisted_4 = { class: "team-group-tooltip_close" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看全部空间", -1))
const _hoisted_6 = { class: "team-base__divider" }
const _hoisted_7 = { class: "team-base__desc" }
const _hoisted_8 = { class: "team-extra" }
const _hoisted_9 = {
  key: 1,
  class: "team-message team-message__wrap",
  id: "notice_trigger"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("登录")
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "team-more" }
const _hoisted_15 = {
  key: 0,
  class: "message-trigger"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_17 = {
  key: 1,
  id: "notice_trigger",
  ref: "messageRef",
  class: "message-trigger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_TeamAvatar = _resolveComponent("TeamAvatar")!
  const _component_TeamInfo = _resolveComponent("TeamInfo")!
  const _component_AvatarGroup = _resolveComponent("AvatarGroup")!
  const _component_TeamMemberList = _resolveComponent("TeamMemberList")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_TeamJoin = _resolveComponent("TeamJoin")!
  const _component_n_dropdown = _resolveComponent("n-dropdown")!
  const _component_n_space = _resolveComponent("n-space")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['team-head-box', { 'team-head-box--ease': _ctx.isEase || false }]),
    ref: "headerRef"
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isLogin && _ctx.showSpaceEnterGuide && _ctx.showTeamListToolTip)
        ? (_openBlock(), _createBlock(_component_n_tooltip, {
            key: 0,
            trigger: "hover",
            show: _ctx.showTeamListToolTip
          }, {
            trigger: _withCtx(() => [
              _withDirectives(_createElementVNode("div", {
                class: "team-group-wrap",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openDrawer && _ctx.openDrawer(...args)))
              }, [
                _createVNode(_component_Icon, {
                  name: "teamAvatar",
                  size: 36,
                  fill: "transparent",
                  class: "team-avatar"
                })
              ], 512), [
                [_vShow, !_ctx.stickyGroupPanel]
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_Icon, {
                    name: "closeColorWhite",
                    onClick: _ctx.closeTeamListTooltip
                  }, null, 8, ["onClick"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["show"]))
        : (_openBlock(), _createBlock(_component_n_tooltip, {
            key: 1,
            trigger: "hover"
          }, {
            trigger: _withCtx(() => [
              _withDirectives(_createElementVNode("div", {
                class: "team-group-wrap",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openDrawer && _ctx.openDrawer(...args)))
              }, [
                _createVNode(_component_Icon, {
                  name: "teamAvatar",
                  size: 36,
                  fill: "transparent",
                  class: "team-avatar"
                })
              ], 512), [
                [_vShow, !_ctx.stickyGroupPanel]
              ])
            ]),
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Icon, {
          name: "divider",
          size: 16,
          fill: "transparent"
        })
      ], 512), [
        [_vShow, !_ctx.stickyGroupPanel]
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.groupStore.current.id || _ctx.hasInviteInfo)
          ? (_openBlock(), _createBlock(_component_TeamAvatar, _mergeProps({
              key: 0,
              modelValue: _ctx.avatar.avatarModel,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.avatar.avatarModel) = $event))
            }, _ctx.avatar.props), null, 16, ["modelValue"]))
          : _createCommentVNode("", true),
        _createVNode(_component_TeamInfo, _normalizeProps(_guardReactiveProps(_ctx.teamInfo.props)), null, 16)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_n_space, {
        size: 12,
        align: "center"
      }, {
        default: _withCtx(() => [
          (_ctx.showTeamMemberEntry && !_ctx.isHiddenTeamMember && !_ctx.hiddenTeamMember)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "team-member",
                style: _normalizeStyle({ pointerEvents: _ctx.isVisitor ? 'none' : 'auto' })
              }, [
                _createVNode(_component_TeamMemberList, null, {
                  trigger: _withCtx((slotProps) => [
                    _createVNode(_component_AvatarGroup, {
                      max: _ctx.maxAvatar,
                      handleTrigger: slotProps.clickTrigger
                    }, null, 8, ["max", "handleTrigger"])
                  ]),
                  _: 1
                })
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.showMessage && !_ctx.isHiddenMessageAlert && !_ctx.hiddenMessageAlert)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_n_button, {
                  tertiary: "",
                  class: _normalizeClass([
              'head-btn',
              'team-message--hover',
              { 'team-message-active': _ctx.isShowMessage }
            ])
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      name: "noMessage",
                      size: 16,
                      fill: "transparent"
                    })
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createElementVNode("div", {
                  id: "notice_counter",
                  class: "notice-area__counter",
                  style: _normalizeStyle({ display: _ctx.isHasMessage ? 'block' : 'none' })
                }, null, 4)
              ]))
            : _createCommentVNode("", true),
          (_ctx.showJoinBtn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_TeamJoin)
              ]))
            : (!_ctx.showJoinBtn && _ctx.showLoginBtn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_n_button, {
                    onClick: _ctx.login,
                    type: "default",
                    style: {"width":"80px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true),
          (!_ctx.isVisitor)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                (_ctx.showShareBtn && !_ctx.isHiddenShareBtn && !_ctx.hiddenShareBtn)
                  ? (_openBlock(), _createBlock(_component_n_button, {
                      key: 0,
                      class: _normalizeClass(['head-btn', 'share-btn--hover']),
                      tertiary: "",
                      onClick: _ctx.showShare
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_Icon, {
                          name: "headShare",
                          size: 16,
                          fill: "transparent"
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.options.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_n_dropdown, {
                        class: "dropdown--default more-dropdown",
                        trigger: "click",
                        placement: "bottom-start",
                        options: _ctx.options,
                        show: _ctx.isShowDropDown,
                        onSelect: _ctx.handleMoreMenuSelect,
                        onUpdateShow: _ctx.updateShowDropDown,
                        ref: "dropdownRef",
                        disabled: _ctx.options.length < 1
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_n_button, {
                              tertiary: "",
                              class: _normalizeClass([
                    'head-btn',
                    'team-more--hover',
                    { 'team-more-active': _ctx.isShowDropDown }
                  ])
                            }, {
                              icon: _withCtx(() => [
                                _createVNode(_component_Icon, {
                                  name: "setting",
                                  size: 16,
                                  fill: "transparent"
                                })
                              ]),
                              _: 1
                            }, 8, ["class"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["options", "show", "onSelect", "onUpdateShow", "disabled"]),
                      (_ctx.showTeamMemberEntry)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createVNode(_component_TeamMemberList, { ref: "MemberPopoverRef" }, {
                              trigger: _withCtx(() => [
                                _hoisted_16
                              ]),
                              _: 1
                            }, 512)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.showMessage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, null, 512))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ], 2))
}